import { SplitterDesignTokens } from '@primeng/themes/types/splitter';

export const baseSplitterToken: SplitterDesignTokens = {
  gutter: {
    background: 'transparent',
  },
  handle: {
    size: '7.125rem',
    background: '{primary.500}',
    borderRadius: '0.75rem',
  },
  css: () => `
    p-splitter.gutter-space-vertical .p-splitter-gutter {
      padding: 1rem 0;
    }

    p-splitter.gutter-space-horizontal .p-splitter-gutter {
      padding-left: 3px;
    }
  `,
};
